import React, { Component } from 'react';
import { Gateway } from '../BaseUrl';
import { shortDateString, dateAndMonth } from '../Functions/Generic';

export class MiniStatement extends Component {
    displayName = MiniStatement.name

    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            loan: this.props.loan || {},
            statement: [],
            slicedStatement: [],
            totalPages: 0,
            totalResults: 0,
            currentPage: 0, 
            prevPage: 0,
            nextPage: 0,
            prevPrevPage: 0,
            nextNextPage: 0,
            firstpage: 0,
            lastpage: 0,
            loading: false,
            hasError: false
        }

        this.getSummary = this.getSummary.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.state.loan.loanReferenceNumber != undefined) {
            this.getSummary();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getSummary() {
        if (this._isMounted) {
            this.setState({
                loading: true
            });
        }
        fetch(Gateway + '/loan/' + this.state.loan.loanReferenceNumber + '/Statement', {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + this.props.token
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                if (response.status == 401) {
                    this.props.Logout(true)
                } else {
                    throw Error(response.status + ": " + response.statusText);
                }
            }
        }).then(data => {
            if (data != null && this._isMounted) {
                //data = [...data, ...data];
                //data = [...data, ...data, ...data, ...data];
                //data = [...data, ...data, ...data, ...data];
                var totPages = Math.ceil(data.length / 3);
                var next = totPages > 1 ? 2 : 0;
                var nextNext = next > 0? ((next + 1) <= totPages) ? next + 1 : 0 : 0;
                this.setState({
                    statement: data,
                    slicedStatement: data.slice(0, 3),
                    totalPages: totPages,
                    totalResults: data.length,
                    currentPage: 1,
                    prevPage: 0,
                    nextPage: next,
                    nextNextPage: nextNext,
                    loading: false,
                    hasError: false
                });
            }

        }).catch((e) => {
            if (this._isMounted) {
                this.setState({
                    loading: false,
                    hasError: true
                });
            }
        });
    };

    changePage(pageNo) {
        var end = pageNo * 3;
        var start = (end - 3) >= 0 ? end - 3 : 0;
        var sliceOfPie = this.state.statement.slice(start, end);
        var prev = ((pageNo - 1) > 0) ? pageNo - 1 : 0;
        var next = ((pageNo + 1) <= this.state.totalPages) ? pageNo + 1 : 0;
        var prevPrev = ((prev - 1) > 0) ? prev - 1 : 0;
        var nextNext = next > 0 ? ((next + 1) <= this.state.totalPages) ? next + 1 : 0 : 0;

        this.setState({
            slicedStatement: sliceOfPie,
            currentPage: pageNo,
            prevPage: prev,
            nextPage: next,
            prevPrevPage: prevPrev,
            nextNextPage: nextNext,
        });
    }

    render() {        
        var showNextNext = false;
        if (this.state.nextNextPage >= this.state.nextPage && this.state.nextNextPage > 0) {
            if (this.state.prevPage <= 0 && this.state.prevPrevPage <= 0) {
                showNextNext = true;
            }
        }
        var showPrevPrev = false;
        if (this.state.prevPrevPage <= this.state.prevPage && this.state.prevPrevPage > 0) {
            if (this.state.nextPage <= 0 && this.state.nextNextPage <= 0) {
                showPrevPrev = true;
            }
        }

        return (
            <div className="mini-statement-container">
                <h3>Statement</h3>
                <div className="mini-statement">

                    {
                        this.state.slicedStatement.map((item, index) =>
                        {
                            return (
                                <div key={index} className="mini-statement-entry">
                                    <div className="mini-statement-detail">
                                        <label>{item.shortDescription}</label>
                                        <p>{dateAndMonth(item.transactionDate)}</p>
                                    </div>
                                    <div className="mini-statement-value">
                                        €{item.amount.toFixed(2)}
                                    </div>
                                </div>
                            )
                        })
                    }

                    <div className="mini-statement-controls">
                        <button onClick={() => this.changePage(1)} className={"btn btn-secondary " + (this.state.currentPage == 1 ? "active" : "")}>First</button>
                        {showPrevPrev && <button onClick={() => this.changePage(this.state.prevPrevPage)} className={"btn btn-secondary " + (this.state.currentPage == this.state.prevPrevPage ? "active" : "")}>{this.state.prevPrevPage}</button>}
                        {this.state.prevPage >= 1 && <button onClick={() => this.changePage(this.state.prevPage)} className={"btn btn-secondary " + (this.state.currentPage == this.state.prevPage ? "active" : "")}>{this.state.prevPage}</button>}
                        {this.state.currentPage >= 1 && <button onClick={() => this.changePage(this.state.currentPage)} className={"btn btn-secondary " + (this.state.currentPage == this.state.currentPage ? "active" : "")}>{this.state.currentPage}</button>}
                        {this.state.nextPage >= this.state.currentPage && <button onClick={() => this.changePage(this.state.nextPage)} className={"btn btn-secondary " + (this.state.currentPage == this.state.nextPage ? "active" : "")}>{this.state.nextPage}</button>}
                        {(showNextNext)&& <button onClick={() => this.changePage(this.state.nextNextPage)} className={"btn btn-secondary " + (this.state.currentPage == this.state.nextNextPage ? "active" : "")}>{this.state.nextNextPage}</button>}
                        <button onClick={() => this.changePage(this.state.totalPages)} className={"btn btn-secondary " + (this.state.currentPage == this.state.totalPages ? "active" : "")}>Last</button>
                    </div>


                    {
                        //prevPrevPage: {this.state.prevPrevPage}<br />
                        //prevPage: {this.state.prevPage}<br />
                        //currentPage: {this.state.currentPage}<br />
                        //nextPage: {this.state.nextPage}<br />
                        //nextNextPage: {this.state.nextNextPage}<br /><br />
                        //totalPage: {this.state.totalPages}<br />
                        //totalResults: {this.state.totalResults}
                    }
                    
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MiniStatement.js